import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9ec5efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oktell-layout layout-chat" }
const _hoisted_2 = { class: "layout-client" }
const _hoisted_3 = { class: "layout-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_connection_state = _resolveComponent("connection-state")!
  const _component_client_card = _resolveComponent("client-card")!
  const _component_call_report_form = _resolveComponent("call-report-form")!
  const _component_ok_whatsapp = _resolveComponent("ok-whatsapp")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_connection_state, {
      "is-connected": _ctx.connectionStore.is_connected
    }, null, 8, ["is-connected"]),
    _createElementVNode("div", _hoisted_2, [
      (!(_ctx.$route.path === '/oktell' || _ctx.$route.path === '/oktell/'))
        ? (_openBlock(), _createBlock(_component_client_card, {
            key: 0,
            loading: _ctx.oktellStore.is_client_loading,
            failed: _ctx.oktellStore.is_client_failed,
            client: _ctx.oktellStore.client,
            "have-whatsapp": _ctx.oktellStore.is_have_whatsapp
          }, null, 8, ["loading", "failed", "client", "have-whatsapp"]))
        : _createCommentVNode("", true),
      (!_ctx.oktellStore.is_client_loading)
        ? (_openBlock(), _createBlock(_component_call_report_form, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.oktellStore.is_have_whatsapp)
        ? (_openBlock(), _createBlock(_component_ok_whatsapp, {
            key: 2,
            phone: _ctx.phone,
            email: _ctx.operatorEmail
          }, null, 8, ["phone", "email"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ])
  ]))
}